// @ts-nocheck
/**
 * drawModeToggles.ts
 * ドローモード切替・編集操作関連メソッド
 * App.vue から切り出し
 */

import {
  featureCollectionAdd,
  markerAddAndRemove,
  markaersRemove,
  scaleAndRotateLassoSelected,
  animateRelocate,
} from '@/js/downLoad'
import { deleteAll } from '@/js/pyramid'
import {
  toggleEditEnabled as toggleEditEnabledCore,
  toggleDrawLasso as toggleDrawLassoCore,
  toggleDrawFree,
  toggleDrawPolygon,
  toggleDrawLine,
  toggleDrawCircle as toggleDrawCircleCore,
  toggleDrawPoint as toggleDrawPointCore,
  toggleDrawText as toggleDrawTextCore,
} from '@/js/draw'
import {
  generateStartEndPointsFromGeoJSON,
  generateSegmentLabelGeoJSON,
  getAllVertexPoints,
  setAllMidpoints,
  updateDragHandles,
  clearSelectedFeature,
  clearFeatureInfo,
} from '@/js/draw'
import { printDirectionChange } from '@/js/downLoad'

type VM = any

// ─── 連続縮小 ───
export function startScaleDown(vm: VM) {
  vm.scaleDownStep = -1
  vm.scaleDownInterval = setInterval(() => {
    vm.scaleDownStep += -1
    vm.scaleValue = vm.scaleValue + vm.scaleDownStep
    onScaleInput(vm, vm.scaleValue)
  }, 100)
}

export function stopScaleDown(vm: VM) {
  if (vm.scaleDownInterval) {
    clearInterval(vm.scaleDownInterval)
    vm.scaleDownInterval = null
  }
  vm.scaleDownStep = -1
}

// ─── スライダーや入力ボックス連動用 ───
export function onScaleInput(vm: VM, value) {
  scaleAndRotateLassoSelected(Number(value), Number(vm.angleValue))
}

// ---- 編集モード 確定/元に戻す（サーバー同期付き） ----
export function onEditConfirm(vm: VM) {
  console.info('[edit-bar] confirm clicked')
  vm.persistAndExitEditMode(false)
}

export function onEditRevert(vm: VM) {
  console.info('[edit-bar] revert clicked')
  // 編集モードを継続したまま直前状態に戻す（サーバー保存なし）
  const map01 = vm.$store.state.map01
  try {
    const src = map01?.getSource('click-circle-source')
    if (!src) return
    if (!vm.$store.state.prevGeojson) return
    const geojson = JSON.parse(JSON.stringify(vm.$store.state.prevGeojson))
    src.setData(geojson)
    // ローカル状態を同期
    vm.$store.state.clickCircleGeojsonText = JSON.stringify(geojson)
    featureCollectionAdd()
    markerAddAndRemove(true)
    generateStartEndPointsFromGeoJSON(geojson)
    generateSegmentLabelGeoJSON(geojson)
    getAllVertexPoints(map01, geojson)
    setAllMidpoints(map01, geojson)
    updateDragHandles(true)
    // 編集モード継続: showDrawConfrimはそのまま
  } catch (e) {
    console.warn('[edit-bar] revert failed', e)
  }
}

// ─── 複製モードを終了 ───
export function exitDuplicateMode(vm: VM) {
  vm.$store.commit('setDrawDuplicate', false)
}

// ─── 編集内容を元に戻す（編集モードは継続） ───
export function revertEditChanges(vm: VM) {
  const map01 = vm.$store.state.map01
  if (map01 && vm.$store.state.prevGeojson) {
    // 編集前の状態に戻す
    const prevGeojson = JSON.parse(JSON.stringify(vm.$store.state.prevGeojson))
    map01.getSource('click-circle-source').setData(prevGeojson)
    vm.$store.state.clickCircleGeojsonText = JSON.stringify(prevGeojson)
    // 矢印とラベルを再生成
    generateStartEndPointsFromGeoJSON(prevGeojson)
    // 距離計測ラベルを再生成
    generateSegmentLabelGeoJSON(prevGeojson)
    // マップのレンダリング完了後にハンドルを更新
    vm.$nextTick(() => {
      // 頂点ハンドルを更新（getAllVertexPointsは内部でsource.setDataを呼ぶ）
      getAllVertexPoints(map01, prevGeojson)
      // 中点ハンドルを更新
      setAllMidpoints(map01, prevGeojson)
      // ドラッグハンドルを更新
      updateDragHandles(true)
    })
    // featureCollectionを更新してからマーカーを再作成（編集モード中なのでforce=true）
    setTimeout(() => {
      featureCollectionAdd()
      markerAddAndRemove(true)
    }, 100)
    // スナックバーで通知
    vm.snackbarText = '編集前の状態に戻しました'
    vm.snackbar = true
  }
}

export async function deleteAllforDraw(vm: VM) {
  vm.s_editEnabled = false
  if (!vm.$store.state.isEditable && !vm.$store.state.isMine) {
    alert('編集不可です!')
    return
  }

  // 確認ダイアログを表示
  const s = vm.$store.state
  s.confirmProps = {
    title: '削除確認',
    okText: '削除',
    cancelText: 'キャンセル',
    persistent: true,
    width: 420,
    color: 'error',
    icon: 'mdi-alert-circle',
    iconColor: 'error',
  }
  s.confirmMessage = '<strong>全ての地物を削除します</strong><br>削除後は「元に戻す」ボタンで復元できます。よろしいですか？'

  const confirmed = await new Promise(resolve => {
    s.confirmResolve = resolve
    s.showConfirm = true
  })

  if (!confirmed) return

  vm.saveHistory()
  deleteAll(true)
  clearFeatureInfo()
  clearSelectedFeature(vm.$store.state.map01)
  setTimeout(() => {
    if (!vm.$store.state.isUsingServerGeojson) {
      featureCollectionAdd()
    }
    markerAddAndRemove(true)
    markaersRemove()
  }, 100)
}

export function directionChange(vm: VM) {
  printDirectionChange(vm.titleDirection)
}

export function toggleEditEnabled(vm: VM) {
  if (!vm.$store.state.isEditable && !vm.$store.state.isMine) {
    alert('編集不可です!')
    return
  }

  // 投げ縄モードがアクティブな場合、編集モード切替時に強制終了・変更破棄
  if ((vm.s_isDrawLasso || vm.s_isLassoSelected) && !vm.s_editEnabled) {
    // 編集モードをONにしようとしている場合、投げ縄モードをキャンセル
    vm.cancelLassoMode()
    return // 編集モードへの切替はキャンセル
  }

  vm.saveHistory()

  // 編集モードがオンからオフになる時（確定時）、投げ縄FWを閉じる
  if (vm.s_editEnabled && vm.s_isLassoSelected) {
    // 投げ縄選択中の地物のlassoSelectedをfalseにする
    const source = vm.map01.getSource('click-circle-source')
    if (source) {
      const geojson = vm.getSourceData(source)
      if (geojson && geojson.features) {
        geojson.features.forEach(f => {
          if (f.properties.lassoSelected) {
            f.properties.lassoSelected = false
          }
        })
        source.setData(geojson)
        vm.$store.state.clickCircleGeojsonText = JSON.stringify(geojson)
      }
    }
    vm.$store.commit('setFloatingVisible', { id: 'lasso-control-window', visible: false })
    vm.s_isLassoSelected = false
    vm.s_isDrawLasso = false
    vm.$store.state.lassoBackupGeojson = null
    vm.angleValue = 0
    vm.scaleValue = 100
  }

  // Call the core edit toggle function
  toggleEditEnabledCore()

  // UI-specific logic
  if (vm.s_editEnabled) {
    vm.snackbarText = '変形、移動時はポップアップができません。'
    vm.snackbar = true
    vm.$nextTick(() => {
      vm.cancelBtnMiniTooltip = '編集ボタンを押す前に戻ります'
      vm.undoBtnMiniTooltip = '使用不可'
      vm.isUndoBtnDisabled = true
      const left = (document.querySelector('#map01').clientWidth / 2) - (vm.drawTool.floatingGroup.offsetWidth / 2)
      const top = 10
      animateRelocate(vm.drawTool.floatingGroup, left, top, { duration: 200, easing: 'ease-out' })
    })
  }
}

export function toggleDrawLasso(vm: VM) {
  if (!vm.$store.state.isEditable && !vm.$store.state.isMine) {
    alert('編集不可です!')
    return
  }

  // Call the core lasso toggle function
  toggleDrawLassoCore()

  // UI-specific logic
  if (vm.s_isDrawLasso) {
    vm.snackbarText = 'ドラッグで投げ縄を書きます！クリックじゃありません！'
    vm.snackbar = true
  }
  document.querySelector('#draw-indicato-text').innerHTML = 'LASSO'
  vm.finishLine()
}

export function toggleLDrawFree(vm: VM) {
  // Call the core free draw toggle function
  toggleDrawFree()

  // UI-specific logic
  if (vm.s_isDrawFree) {
    vm.snackbarText = 'ドラッグで線を書きます！クリックじゃありません！'
    vm.snackbar = true
  }
  document.querySelector('#draw-indicato-text').innerHTML = 'FREE'
  vm.finishLine()
}

export function toggleLDrawPolygon(vm: VM) {
  // Call the core polygon draw toggle function
  toggleDrawPolygon()

  // UI-specific logic
  document.querySelector('#draw-indicato-text').innerHTML = 'POLYGON'
  vm.finishLine()
}

export function toggleLDrawLine(vm: VM) {
  // Call the core line draw toggle function
  toggleDrawLine()

  // UI-specific logic
  document.querySelector('#draw-indicato-text').innerHTML = 'LINE'
  vm.finishLine()
}

export function toggleDrawCircle(vm: VM) {
  // Call the core circle draw toggle function
  toggleDrawCircleCore()

  // UI-specific logic
  document.querySelector('#draw-indicato-text').innerHTML = 'CIRCLE'
  vm.finishLine()
}

export function toggleDrawPoint(vm: VM) {
  // Call the core point draw toggle function
  toggleDrawPointCore()

  // UI-specific logic
  document.querySelector('#draw-indicato-text').innerHTML = 'TXT'
  vm.finishLine()
}

export function toggleDrawText(vm: VM) {
  // Call the core text draw toggle function
  toggleDrawTextCore()

  // UI-specific logic
  document.querySelector('#draw-indicato-text').innerHTML = vm.$store.state.isDrawText ? 'ABC' : ''
  vm.finishLine()
}
